import { localized } from "@msuite/ui/localization";
import {
	createColumnHelper,
	createMeta,
	createRowActions,
	createSubRowHandle,
} from "@msuite/ui/table";
import { WarehouseZoneTag } from "@msuite/ui/tag";
import {
	getWarehouseLocationNumberSegmentString,
	getWarehouseZoneTypeTranslationKey,
} from "@msuite/utils/stock";
import { guardNumber } from "@msuite/utils/numbers";
import { guardString } from "@msuite/utils/strings";
import type { WarehouseZoneListItem } from "@msuite/utils/types";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<WarehouseZoneListItem>();

export const columns = [
	createSubRowHandle<WarehouseZoneListItem>(),
	columnHelper.accessor("name", {
		id: "name",
		header: localized("general.name"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("number", {
		id: "number",
		header: localized("stock.warehouse_zone_number"),
		cell: (cell) => getWarehouseLocationNumberSegmentString(cell.getValue()),
	}),
	columnHelper.accessor("warehouseLocationCount", {
		id: "warehouseLocations",
		header: localized("stock.warehouse_locations"),
		cell: (cell) => guardNumber(cell.getValue()),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	columnHelper.accessor((row) => localized(getWarehouseZoneTypeTranslationKey(row.type)), {
		id: "type",
		header: localized("general.type"),
		cell: (cell) => <WarehouseZoneTag type={cell.row.original.type} />,
	}),
	columnHelper.accessor("followUpZoneName", {
		id: "followUpZoneName",
		header: localized("stock.follow_up_zone"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	createRowActions(RowActions),
];
